import { useKeycloak } from '@tecsinapse-org/portal-menu-kit/src'

export const useRealm = (): string | null => {
  const keycloak = useKeycloak()
  return keycloak.keycloak.realm ?? null
}
